export default {
  data(){
    return {
      breadcrumb: [{ label: "Trung tâm trợ giúp", path: "/docs"}],
    };
  },

  computed: {
    user() {
      return this.$store.state.auth.user;
    }
  }
};
